import { DialogRef } from '@angular/cdk/dialog';
import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserOnboardingService } from '@app/modules/user-onboarding/services';
import { ToastrService } from 'ngx-toastr';
import { Optional } from '@angular/core';
import { ModalService } from '@app/services/modal/modal.service';
import { UserSettingsAutoinvestActivateComponent } from '@app/modules/user-settings/user-settings-autoinvest-activate/user-settings-autoinvest-activate.component';
import { MatDialog } from '@angular/material/dialog';
import { ContractService } from '@app/services';

@Component({
  selector: 'mnf-profile-legal',
  templateUrl: './profile-legal.component.html',
  styleUrls: ['./profile-legal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProfileLegalComponent implements OnInit{

  @Output() next = new EventEmitter();
  @Input() user: any;

  formToSend: FormGroup;

  operationPerMonth = [
    { value: 5, text: '1 a 5 operaciones' },
    { value: 10, text: '6 a 10 operaciones' },
    { value: 11, text: 'Más de 10 operaciones' },
  ];
  
  amountsPerOperation = [
    { value: 10000, text: '0 a 10 mil pesos' },
    { value: 50000, text: '10 a 50 mil pesos' },
    { value: 100000, text: '50 a 100 mil pesos' },
    { value: 500000, text: '100 a 500 mil pesos' },
    { value: 500001, text: 'Más de 500 mil pesos' },
  ];

  origenMoney = [
    { value: 'Salarios', text: 'Ingresos de salario' },
    { value: 'Negocio', text: 'Negocio' },
    { value: 'Donación familiar', text: 'Donación familiar' },
    { value: 'Herencia', text: 'Herencia' },
    //{ value: 'Otro', text: 'Otro' }
  ];

  destinationInvestment = [
    { value: 'Ahorro o inversión', text: 'Ahorro o inversión' },
    { value: 'Ahorro para retiro', text: 'Ahorro para retiro' },
    { value: 'Adquirir bienes', text: 'Adquirir bienes' },
    // { value: 'Otro', text: 'Otro' }
  ]

  constructor(
    private fb: FormBuilder,
    private onBoardServ: UserOnboardingService,
    private toastr: ToastrService,
    private modalServ: ModalService,
    private dialog: MatDialog,
    private contractService: ContractService,
    @Optional() private dialogRef: DialogRef<ProfileLegalComponent>
  ) { }

  ngOnInit(): void {
    this.formToSend = this.fb.group({
      operationPerMonth: ['', Validators.compose([Validators.required])],
      amountsPerOperation: ['', Validators.compose([Validators.required])],
      origenMoney: ['', Validators.compose([Validators.required])],
      destinationInvestment: ['', Validators.compose([Validators.required])],
      //answerUser: ['', Validators.compose([Validators.required, Validators.maxLength(250)])]
    });
  }

  sendInfo() {
    if (this.formToSend.valid) {
      let valueForm = this.formToSend.value;
      let objectToSend = {
        operationPerMonth: valueForm.operationPerMonth,
        amountsPerOperation: valueForm.amountsPerOperation,
        origenMoney: valueForm.origenMoney,
        destinationInvestment: valueForm.destinationInvestment,
        //answerUser: valueForm.answerUser,
        limitUserOperation: valueForm.operationPerMonth * valueForm.amountsPerOperation
      }

      this.onBoardServ.setMaxOperationPerMonth(objectToSend).subscribe(res => {
        if(res) {
          this.toastr.success('Información guardada correctamente')
          this.autoInvest();
        }
      })
    }
  }


  autoInvest() {
    let modalAutoInvest = this.modalServ.modalCustom({
      header: 'Aviso',
      title: '¿Te gustaría activar el motor de autoinversión?',
      message: 'Con el motor de autoinversión, tu dinero se invertirá automáticamente en los proyectos de tu criterio. Podrás activarlo o desactivarlo en cualquier momento desde tu perfil.',
      buttonText: 'Continuar',
      cancelText: 'No, gracias'
    });

    modalAutoInvest.beforeClosed().subscribe(res => {
      if(res) {
         let m1 = this.dialog.open(UserSettingsAutoinvestActivateComponent, {
            maxWidth: '650px',
            width: '95%',
            panelClass: 'mnf-modal-container',
            height: '90vh',
            autoFocus: false,
            ariaModal: true,
         });

         m1.afterClosed().subscribe(() => {
            this.contractService.contractAccepted$.subscribe(accepted => {
               if(accepted) {
                  this.dialogRef.close();
                  this.next.next(this.user);
               }
            });
         });

      } else {
        this.next.next(this.user);
        this.dialogRef.close()
      }
   });

  }

}
